import React, { useEffect, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";

const initialState = {
  id: "",
  title: "",
  description: "<p><br></p>",
  metaTitle: "",
  metaDescription: "",
  metaKeywords: "",
};

const CMSForm = (props) => {
  const { title } = props;
  const editor = useRef("");
  const { id } = useParams();
  const nav = useNavigate();
  console.log(";id", id);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();


  const [formData, setFormData] = useState(initialState);

  const config = {
    placeholder: "Start Typing...",
  };

  const handleChange = (event) => {
    setFormData((preval) => ({
      ...preval,
      [event.target.name]: event.target.value,
    }));
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    // setSubmitted(true);
    formData.description = editor.current.value;
    console.log("formData", formData);
    try {
      const data = await fetch(process.env.REACT_APP_API_URL + "update-cms-page", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-type": "application/json",
        },
      });
      const response = await data.json();
      if (response) {
        window.scrollTo(0, 0);
        setTimeout(() => {
          nav("/admin/cms-pages");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetHandler = () => {
    // setSubmitted(false);
    editor.current.value = initialState.description;
    setFormData(initialState);
  };

  useEffect(() => {
    (async () => {
      if (id) {
        const response = await fetch(`${process.env.REACT_APP_API_URL}cms-details/${id}`);
        const resData = await response.json();
        if (resData.status === true) {
          setFormData({
            id: resData.details._id,
            title: resData.details.title,
            description: resData.details.description,
            metaTitle: resData.details.metaTitle,
            metaDescription: resData.details.metaDescription,
            metaKeywords: resData.details.metaKeywords,
          });
          editor.current.value = resData.details.description;
        } else {
          // redirect to cms listing page
          nav("/admin/cms-pages");
        }
      }
    })();
  }, [id]);

  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-flex align-items-center mb-4">
            <h4 className="fs-20 font-w600 mb-0 me-auto">{title}</h4>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <form onSubmit={handleSubmit(submitHandler)}>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-12 mb-4">
                        <label className="form-label font-w600" htmlFor="title">
                          Title :
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control solid"
                          id="title"
                          name="title"
                          onChange={handleChange}
                          defaultValue={formData.title}
                          {...register("title", { required: true })}
                        />
                        {errors.title && (
                          <p style={{ color: "red" }}>This field is required</p>
                        )}
                      </div>

                      <div className="col-lg-12 mb-4">
                        <label
                          className="form-label font-w600"
                          htmlFor="description"
                        >
                          Description :
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>

                        <JoditEditor
                          ref={editor}
                          defaultValue={formData.description}
                          config={config}
                          tabIndex={1} // tabIndex of textarea
                          id="description"
                          // {...register("description", {required:true})}
                        />
                        {/* {errors.description&& (
                            <p style={{ color: "red" }}>
                              This field is required
                            </p>
                          )} */}
                      </div>

                      <div className="col-xl-12 col-md-12 mb-4">
                        <h5>SEO details:</h5>
                      </div>
                      <div className="row">
                        <div className="col-md-4 mb-4">
                          <label
                            className="form-label font-w600"
                            htmlFor="meta-title"
                          >
                            Meta Title :
                            <span className="text-danger scale5 ms-2">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              id="meta-title"
                              name="metaTitle"
                              className="form-control solid"
                              onChange={handleChange}
                              defaultValue={formData.metaTitle}
                              {...register("metaTitle", { required: true })}
                            />
                          </div>
                          {errors.metaTitle && (
                            <p style={{ color: "red" }}>
                              This field is required
                            </p>
                          )}
                        </div>

                        <div className="col-md-4 mb-4">
                          <label
                            className="form-label font-w600"
                            htmlFor="meta-description"
                          >
                            Meta Description :
                            <span className="text-danger scale5 ms-2">*</span>
                          </label>
                          <div className="input-group">
                            <textarea
                              type="text"
                              id="meta-description"
                              name="metaDescription"
                              className="form-control solid"
                              onChange={handleChange}
                              defaultValue={formData.metaDescription}
                              rows={10}
                              column={10}
                              {...register('metaDescription', {required: true})}
                            />
                          </div>
                          {errors.metaDescription && (
                            <p style={{ color: "red" }}>
                              This field is required
                            </p>
                          )}
                        </div>

                        <div className="col-md-4 mb-4">
                          <label
                            className="form-label font-w600"
                            htmlFor="meta-keywords"
                          >
                            Meta Keyword :
                            <span className="text-danger scale5 ms-2">*</span>
                          </label>
                          <div className="input-group">
                            <textarea
                              type="text"
                              id="meta-keywords"
                              name="metaKeywords"
                              className="form-control solid"
                              onChange={handleChange}
                              defaultValue={formData.metaKeywords}
                              rows={15}
                              column={10}
                              {...register('metaKeywords', {required:true})}
                            />
                          </div>
                          {errors.metaKeywords && (
                            <p style={{ color: "red" }}>
                              This field is required
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div>
                      <button type="submit" className="btn btn-secondary mx-2 ">
                        Save
                      </button>
                      <button
                        type="reset"
                        className="btn btn-warning"
                        onClick={resetHandler}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CMSForm;
